import.meta.glob(["../images/**", "../fonts/**"]);
//
import './bootstrap/app';

import './bootstrap/plugins';
import './bootstrap/directives';
import './bootstrap/components';
import './bootstrap/primevue';

import { initLazyImages } from './services/lazy-images';
import { initAnchorScroll } from './services/anchor-scroll';
import { initHomeCategories } from './services/home-categories';
import { initAriaFix } from './services/aria-fix';

import {
    initReviewsSwiper,
    initAllSwipers,
    initNewProductsSwiper,
    initPromotionsSwiper,
    initBrandsSwiper,
    initFeaturedProductsSwiper,
} from './services/swiper';

function initAppServices() {
    requestAnimationFrame(() => {
        initLazyImages();
        initAnchorScroll();
        initHomeCategories();
        initAriaFix();

        initFeaturedProductsSwiper();

        [
            ".bestsellers-swiper",
            ".recently-viewed-swiper",
            ".mobileCategoriesSwiper",
            ".brands-mobile-swiper",
        ].forEach(initAllSwipers);

        initBrandsSwiper();
        initReviewsSwiper(".reviews-swiper");
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAppServices);
} else {
    initAppServices();
}
